import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventStatus, JoiEvent } from 'globals/store/events.data';
import { EventStatusComponent } from 'src/app/components/events/event-status.component';

@Component({
    selector: 'edit-event-status-dialog',
    template: `
      <div class="joi-dialog">
          <div mat-dialog-title>
             Edit Event Status
          </div>
          <div mat-dialog-content>
              <div class="dialog_content">
                  <div class="para">
                      Update your event status:
                  </div>
                  <event-status 
                    [eventId]="data.eventId" 
                    [dotOnly]="false" 
                    [outsideEvent]="true" 
                    (changeStatus)="tempStatus = $event"
                  ></event-status>
              </div>
          </div>
          <div mat-dialog-actions class="lg">
              <button mat-button (click)="dialogRef.close()">Cancel</button>
              <button mat-button color="primary" (click)="updateEvent()">Save</button>
          </div>
      </div>
  `,
    styles: [`
  .joi-dialog .para { margin-bottom: 15px; }
  `],
    standalone: true,
    imports: [EventStatusComponent],
})
export class EditEventStatusDialogComponent {
  tempStatus: Omit<EventStatus, 'Completed'>
  constructor(public dialogRef: MatDialogRef<EditEventStatusDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: JoiEvent) {}
  updateEvent() {
    this.dialogRef.close(this.tempStatus);
  }
}

export interface EditEventNameData { event_name: string }
